import type { QueryClient } from '@tanstack/vue-query'
import type { Message } from '../model/message'
import type { MessagesQueryData } from '../model/messages-query-data'
import { areMessagesEqual } from './are-messages-equal'
import { getFreshMessagesQueryKey } from './fresh-messages-query'
import { getMessagesQueryKeyPrefixByChat } from './messages-query'

export async function updateMessage(queryClient: QueryClient, message: Message) {
  queryClient.setQueryData(getFreshMessagesQueryKey(message.chatId), (queryData: Message[] | undefined) => {
    if (!queryData) return

    return queryData.map(existingMessage => {
      if (existingMessage.id === message.id || (message.clientId && existingMessage.clientId === message.clientId))
        return message
      return existingMessage
    })
  })

  queryClient.setQueriesData(
    { queryKey: getMessagesQueryKeyPrefixByChat(message.chatId) },
    (queryData: MessagesQueryData | undefined) => {
      if (!queryData) return

      const newPages = queryData.pages.map(page => ({
        ...page,
        data: page.data.map(existingMessage => {
          if (areMessagesEqual(existingMessage, message)) return message
          return existingMessage
        }),
      }))

      return {
        ...queryData,
        pages: newPages,
      }
    }
  )
}
